const handleEnterPress = (
  e: React.KeyboardEvent<HTMLInputElement>,
  callBack: any
) => {
  if ((e.code = 'Enter')) {
    callBack()
    return
  }
  return
}

export default handleEnterPress
